import { Yup, type YupTypes, inputFileSchema } from "@pharmupp/p3-front-commons"
import { fields } from "../../components"

export const schema = Yup.object({
  publishLater: Yup.boolean(),
  publicationDate: Yup.date().when(
    fields.publishLater,
    ([publishLater]: boolean[], schemaRef) =>
      publishLater === true ? schemaRef.required() : schemaRef,
  ),
  title: Yup.string().max(100).required(),
  description: Yup.string().required(),
  image: inputFileSchema.default(undefined).notRequired(),
  isFlash: Yup.boolean().required(),
  restrictedUppIds: Yup.array().of(Yup.number().required()),
  diffusion: Yup.string().required(),
})

export type LaboratoryNewsFormValues = YupTypes.InferType<typeof schema>
